import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../api';
import { DetailSkeleton } from '../components/LoadingSkeleton';
import YouTubePlayer from '../components/YouTubePlayer';
import { normalizeMediaUrl, DEFAULT_POSTER_SVG } from '../utils/media';

export default function VideoDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    setLoading(true);
    api.getVideo(id)
      .then((data) => { if (!cancelled) setVideo(data); })
      .catch((err) => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [id, user]);

  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  if (loading) return <DetailSkeleton />;

  if (error || !video) {
    return (
      <div className="not-found">
        <h2>Video not found</h2>
        <Link to="/">Back to Home</Link>
      </div>
    );
  }

  const price = Number(video.price).toFixed(2);
  const posterUrl = normalizeMediaUrl(video.thumbnail) || DEFAULT_POSTER_SVG;

  const handlePurchase = () => {
    navigate(`/payment/video/${video.id}`);
  };

  return (
    <div className="detail-page">
      <div className="detail-container">
        <div className="detail-trailer">
          {video.trailer_url ? (
            <YouTubePlayer
              src={video.trailer_url}
              poster={posterUrl}
              title={`${video.title} - Official Trailer`}
              autoPlay={false}
            />
          ) : (
            <video controls poster={posterUrl}>
              <source src={video.trailer_url} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="detail-info">
          <h1 className="detail-title">{video.title}</h1>
          <div className="detail-meta">
            {video.year && <span>{video.year}</span>}
            {video.genre && <span>{video.genre}</span>}
            {video.rating && <span>{video.rating}</span>}
            {video.duration && <span>{video.duration}</span>}
          </div>
          <p className="detail-description">{video.description}</p>
          <div className="detail-price">TSh {price}</div>
          {video.purchased ? (
            <button className="btn btn-primary" onClick={() => navigate(`/watch/${video.id}`)}>
              Watch Now
            </button>
          ) : (
            <button className="btn btn-primary" onClick={handlePurchase}>
              Purchase - TSh {price}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
